import type { HouseholdInsightsApiResponse } from '../apiTypes';
import type { MetricListItem } from '../chartTypes';
import { HOUSEHOLD_PROFILE_BUCKETS } from '../constants';
import { parseMetricList } from './utils';

export const parseHouseholdProfile = (response: HouseholdInsightsApiResponse | undefined): MetricListItem[] =>
  parseMetricList(response?.household_profile, HOUSEHOLD_PROFILE_BUCKETS);
